/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyBaseDataWithClients } from './companyBaseDataWithClients';
import { Asset } from './asset';


export interface Collection { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    name: string;
    description?: string;
    /**
     * MongoDB ObjectId of the cover asset
     */
    coverAssetID?: string;
    ownerIDs?: Array<string>;
    /**
     * Asset list
     */
    assets?: Array<Asset>;
    assetData?: Asset;
    keywords?: Array<string>;
    customFields?: object;
    published?: Array<CompanyBaseDataWithClients>;
}

